export default __webpack_public_path__ + "static/ar-flow-9432aefadfb8f5fd77d2ec4f8eee7291.mp4";